import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ButtonGroup from 'reactstrap/lib/ButtonGroup';
import { noop } from 'lodash-es';
import { Tab } from './tab';

import './tabs-panel.scss';

export function TabsPanel({
  options,
  selectedOption,
  onTabClick = noop,
  className = '',
  tabClassName = 'pt-0 pb-0_5 px-1',
  labelClassName = '',
  activeLabelClassName = '',
  iconClassName = '',
  ariaLabel = undefined,
}) {
  return (
    <ButtonGroup className={classnames('tabs-panel', className)} role="tablist" aria-label={ariaLabel}>
      {options.map(({ value, label, icon, link, trackingId, trackingValue, dataTest, disabled, ariaControls }) => {
        const isActive = selectedOption === value;
        return (
          <Tab
            key={value}
            tabId={value}
            color="link"
            isActive={isActive}
            onClick={onTabClick}
            label={label}
            icon={icon}
            className={tabClassName}
            trackingId={trackingId}
            trackingValue={trackingValue}
            dataTest={dataTest}
            link={link}
            labelClassName={classnames(labelClassName, { [activeLabelClassName]: isActive })}
            iconClassName={iconClassName}
            disabled={disabled}
            ariaControls={ariaControls}
          />
        );
      })}
    </ButtonGroup>
  );
}

TabsPanel.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
      link: PropTypes.string,
      icon: PropTypes.string,
      trackingId: PropTypes.string,
      trackingValue: PropTypes.string,
      dataTest: PropTypes.string,
      disabled: PropTypes.bool,
      ariaControls: PropTypes.string,
    })
  ).isRequired,
  selectedOption: PropTypes.string.isRequired,
  onTabClick: PropTypes.func,
  className: PropTypes.string,
  tabClassName: PropTypes.string,
  activeLabelClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  iconClassName: PropTypes.string,
  ariaLabel: PropTypes.string,
};
